import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router';

import type { AppointmentReportDue } from '../../api/types';
import { useProject } from '../../projects/context';
import { projectKeys, useProjectApi } from '../../projects/useProjectApi';
import { fmtDate, fmtTime } from '../format';
import { ReportWizard } from './ReportWizard';

const SEEN = 'em-report-prompted';

// Termine nachbereiten (OFFENE_FRAGEN B-29 Phase 2): Auf der Startseite des Maklers stehen die eigenen Termine, die vorbei
// sind und noch keinen Bericht haben. Beim ersten Öffnen der App öffnet sich der Fragenkatalog zum ältesten Termin von
// selbst – je Sitzung und Termin einmal; danach bleibt der Hinweis stehen, bis der Bericht abgeschickt ist.
export function DueReports() {
  const { project } = useProject();
  const papi = useProjectApi();
  const due = useQuery({ queryKey: projectKeys.dueReports(project.id), queryFn: ({ signal }) => papi.dueAppointmentReports(signal), refetchInterval: 300_000 });
  const [open, setOpen] = useState<AppointmentReportDue | null>(null);
  const [seen, setSeen] = useState(() => sessionStorage.getItem(SEEN));
  const items = due.data?.items ?? [];
  if (items.length === 0) return null;
  const first = items[0];
  const current = open ?? (first && seen !== first.appointment_id ? first : null);
  const close = () => {
    if (current) {
      sessionStorage.setItem(SEEN, current.appointment_id);
      setSeen(current.appointment_id);
    }
    setOpen(null);
  };
  return (
    <section className="card due-reports" aria-labelledby="due-reports-title">
      <div className="section-head">
        <h2 id="due-reports-title">
          Termine nachbereiten <span className="badge badge-warn">{items.length}</span>
        </h2>
      </div>
      <p className="muted small">Ein paar Fragen je Termin – danach weiß das Team, was als Nächstes passiert.</p>
      <ul className="today-list">
        {items.map((it) => (
          <li key={it.appointment_id} className="today-item">
            <span className="today-time">
              {fmtDate(it.start_at)} {fmtTime(it.start_at)}
            </span>
            <span className="today-lead">
              <Link to={`/p/${project.key}/termine/${it.appointment_id}`}>{it.lead_name ?? 'Termin'}</Link>
              {it.city ? ` · ${it.city}` : ''}
            </span>
            <button type="button" className="btn btn-small btn-primary" onClick={() => setOpen(it)}>
              Nachbereiten
            </button>
          </li>
        ))}
      </ul>
      {current && <ReportWizard appointmentId={current.appointment_id} title={`${current.lead_name ?? 'Termin'}, ${fmtDate(current.start_at)}`} onClose={close} />}
    </section>
  );
}
